import React from 'react';

export interface QRCodeProps {
  value: string;
  size?: number;
}

/**
 * Minimal QR Code generator using an img tag with an external service
 * No additional dependencies required
 */
export const QRCode: React.FC<QRCodeProps> = ({ value, size = 200 }) => {
  // Use QuickChart.io as a simple, reliable QR code generator
  const qrUrl = `https://quickchart.io/qr?text=${encodeURIComponent(value)}&size=${size}`;

  return (
    <div style={{ textAlign: 'center' }}>
      <img 
        src={qrUrl} 
        alt="QR Code" 
        width={size} 
        height={size}
        style={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}
      />
    </div>
  );
};
